import React from 'react';
import theme from '../../theme';
import { IconProps } from './props'

const StatementIcon: React.FC<IconProps> = ({ id, iconColor = theme.textDark, ...rest }) => (
    <svg
        id={id}
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...rest}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.07812 0.263184L5.92247 1.98886L8.914 0.263184L11.7648 1.98886L14.8973 0.263184L17.9877 1.98886L21.0781 0.263184V24.2632L17.9877 22.3215L14.8973 24.2632L11.7648 22.3215L8.914 24.2632L5.92247 22.3215L3.07812 24.2632V0.263184ZM5.07812 3.8159V20.4764L5.89451 19.9191L8.88732 21.8615L11.7134 19.9367L14.8901 21.9057L17.9877 19.9596L19.0781 20.6447V3.67065L17.9877 4.27954L14.8907 2.5502L11.7176 4.29822L8.88948 2.58623L5.89678 4.31258L5.07812 3.8159Z"
            fill={iconColor}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.75781 17.177C6.75781 16.6247 7.20553 16.177 7.75781 16.177H16.3982C16.9505 16.177 17.3982 16.6247 17.3982 17.177C17.3982 17.7293 16.9505 18.177 16.3982 18.177H7.75781C7.20553 18.177 6.75781 17.7293 6.75781 17.177Z"
            fill={iconColor}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.74904 6.51196C6.74904 5.95968 7.19675 5.51196 7.74904 5.51196L16.398 5.51196C16.9503 5.51196 17.398 5.95968 17.398 6.51196C17.398 7.06425 16.9503 7.51196 16.398 7.51196L7.74904 7.51196C7.19675 7.51196 6.74904 7.06425 6.74904 6.51196Z"
            fill={iconColor}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.75098 13.6221C6.75098 13.0698 7.19869 12.6221 7.75098 12.6221L16.3981 12.6221C16.9504 12.6221 17.3981 13.0698 17.3981 13.6221C17.3981 14.1744 16.9504 14.6221 16.3981 14.6221L7.75098 14.6221C7.19869 14.6221 6.75098 14.1744 6.75098 13.6221Z"
            fill={iconColor}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.7627 10.0669C6.7627 9.51461 7.21041 9.06689 7.7627 9.06689L16.3985 9.06689C16.9507 9.06689 17.3985 9.51461 17.3985 10.0669C17.3985 10.6192 16.9507 11.0669 16.3985 11.0669L7.7627 11.0669C7.21041 11.0669 6.7627 10.6192 6.7627 10.0669Z"
            fill={iconColor}
        />
    </svg>
);

export { StatementIcon };